export const ProductsTypes = {
    SET_PRODUCTS: "SET_PRODUCTS",
    SELECTED_PRODUCT: "SELECTED_PRODUCT",
    REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",
}

export const DashboardTypes = {
    DASHBOARD_DATA: "DASHBOARD_DATA",
}
